module.exports = __webpack_public_path__ + "static/media/loader.561949c0.svg";